import Phaser from 'phaser';

export default class Background extends Phaser.GameObjects.TileSprite {
  constructor({ scene, x, y, width, height, key }) {
    super(scene, x, y, width, height, key);

    this.scene.add.existing(this);
    this.setOrigin(0, 1);
    this.setScrollFactor(0);
  }
}

export function preload(key, asset) {
  this.load.image(key, `Background/${asset}`);
}
